import { EntityLink } from '@/shared/ui/entity-link'

interface EntityRefProps {
  id: string
  label?: string
  className?: string
}

export function ScenarioLink({ id, label, className }: EntityRefProps) {
  return (
    <EntityLink
      to="/scenarios/$scenarioId"
      params={{ scenarioId: id }}
      icon="pen"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}
